import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";
import { trackEvent } from "./analytics";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("cv_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("cv_token");
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("cv_token", r.data.access_token);
    setUser(r.data.user);
    trackEvent("login", { method: "password" });
    return r.data.user;
  };

  const kidLogin = async (parentEmail, nickname, pin) => {
    const r = await api.post("/auth/kid-login", {
      parent_email: parentEmail,
      nickname,
      pin,
    });
    localStorage.setItem("cv_token", r.data.access_token);
    setUser(r.data.user);
    trackEvent("login", { method: "kid_pin" });
    return r.data.user;
  };

  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    localStorage.setItem("cv_token", r.data.access_token);
    setUser(r.data.user);
    trackEvent("sign_up", { method: "password", role: payload.role || "parent" });
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("cv_token");
    setUser(null);
  };

  const refresh = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
    return r.data;
  };

  return (
    <AuthCtx.Provider
      value={{ user, loading, login, kidLogin, register, logout, refresh }}
    >
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
